/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_Settings_HintInputs */

const en_us2_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications, appearance, workout on this device and account`)
};

const pt_br2_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações, aparência, treino neste aparelho e conta`)
};

const es_419_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones, apariencia, entrenamiento en este dispositivo y cuenta`)
};

const pt_pt2_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações, aspeto, treino neste dispositivo e conta`)
};

const fr_fr2_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications, apparence, séance sur cet appareil et compte`)
};

const de_de2_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen, Darstellung, Training auf diesem Gerät und Konto`)
};

const it_it2_profile_page_settings_hint = /** @type {(inputs: Profile_Page_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche, aspetto, allenamento su questo dispositivo e account`)
};

/**
* | output |
* | --- |
* | "Notifications, appearance, workout on this device and account" |
*
* @param {Profile_Page_Settings_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_settings_hint = /** @type {((inputs?: Profile_Page_Settings_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_Settings_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_settings_hint(inputs)
	if (locale === "es-419") return es_419_profile_page_settings_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_settings_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_settings_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_page_settings_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_page_settings_hint(inputs)
	return en_us2_profile_page_settings_hint(inputs)
});
export { profile_page_settings_hint as "profile.page_settings_hint" }